import { Card, Chip as MuiChip, Grid, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'

type CalendarTableInfoComponent = React.FC

const Chip = ({ label, bgColor }: { label: string; bgColor: string }) => {
    const theme = useTheme()

    return (
        <MuiChip
            label={label}
            sx={{
                height: 20,
                padding: 0,
                backgroundColor: bgColor,
                color: theme.palette.common.black,
            }}
        />
    )
}

export const CalendarTableInfo: CalendarTableInfoComponent = () => {
    return (
        <Card
            sx={{
                marginTop: 4,
                marginBottom: 4,
                padding: 4,
            }}
        >
            <Typography
                sx={{
                    fontWeight: 800,
                    pb: 4,
                    fontSize: '16px',
                }}
            >
                Förklaring
            </Typography>
            <Grid container spacing={4}>
                <Grid>
                    <Stack
                        direction='row'
                        spacing={1}
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        <Chip label='Ink' bgColor='#ffc100' />
                        <Typography>Sista dagen för att erhålla rätter</Typography>
                    </Stack>
                </Grid>
                <Grid>
                    <Stack
                        direction='row'
                        spacing={1}
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        <Chip label='Ex' bgColor='#ff9a00' />
                        <Typography>Första handelsdagen exklusive rätter</Typography>
                    </Stack>
                </Grid>
                <Grid>
                    <Stack
                        direction='row'
                        spacing={1}
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        <Chip label='TR' bgColor='#d896ff' />
                        <Typography>Sista handelsdagen för rätter</Typography>
                    </Stack>
                </Grid>
                <Grid>
                    <Stack
                        direction='row'
                        spacing={1}
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        <Chip label='Teckning' bgColor='#8ecae6' />
                        <Typography>Teckningsperiod</Typography>
                    </Stack>
                </Grid>
                <Grid>
                    <Stack
                        direction='row'
                        spacing={1}
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        <Chip label='IPO' bgColor='#a1d99b' />
                        <Typography>Första handelsdagen</Typography>
                    </Stack>
                </Grid>
            </Grid>
        </Card>
    )
}
